//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import TRA_BASIC_01 from './TRA_BASIC_01';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
//#endregion

function TRA_BASIC_01F(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const rowClickData = useRef(null);
  //교육현황 그리드
  const gridRef1 = useRef();
  const [rowData1, setRowData1] = useState([]); // 교육현황 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육현황 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육현황 그리드 변경 시 데이터
  //참석자정보 그리드
  const gridRef2 = useRef();
  const [rowData2, setRowData2] = useState([]); // 참석자정보 그리드 데이터
  const [selectedRowData2, setSelectedRowData2] = useState([]); // 참석자정보 그리드 클릭 시 데이터
  const [changedRowData2, setChangedRowData2] = useState([]); // 참석자정보 그리드 변경 시 데이터
  const tbmCdRef = useRef(''); // 셀 클릭 시 tbmCd
  const [modalToggle1, setModalToggle1] = useState(false);

  //#endregion

  //#region 조회
  //교육현황 조회(_value1:사업장코드)
  const SearchLogic1 = async (_value1) => {
    ResetLogic1();

    dispatch(showLoading());
    try {
      // 검색 연월 추출 (currentYear, currentMonth 사용)
      const currentYear = searchInfo?.currentYear;
      const currentMonth = searchInfo?.currentMonth;

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_01_R1',
            _YEAR: Commons.EncryptAES(currentYear || dayjs().format('YYYY')),
            _MONTH: Commons.EncryptAES(currentMonth || dayjs().format('MM')),
            _CUST_CD: Commons.EncryptAES(_value1),
            _SEARCH_TEXT: Commons.EncryptAES('') || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          setRowData1(Commons.InsertNumber(data));
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  //참석장 정보 조회(value1: TBM코드)
  const SearchLogic2 = async (_value1) => {
    ResetLogic2();
    dispatch(showLoading());
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_01_R2',
            _TBM_CD: Commons.EncryptAES(_value1),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          setRowData2(Commons.InsertNumber(data));
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion
  //#region 저장
  //교육현황 저장
  const SaveLogic1 = async () => {
    dispatch(showLoading());
    try {
      const changedRows = changedRowData1.filter((row) => !row.deleteYn);
      const hasChange = changedRows.length > 0;

      if (!hasChange) {
        dispatch(
          showSnackbar({
            message: '변경된 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      const saveData = changedRows.map((item) => ({
        procedureName: 'SP_TRA_BASIC_01_U1',
        _TBM_CD: Commons.EncryptAES(item.TBM_CD) || '',
        _TBM_TITLE: Commons.EncryptAES(item.TBM_TITLE) || '',
        _TBM_ADDRESS: Commons.EncryptAES(item.TBM_ADDRESS) || '',
        _REMARK: Commons.EncryptAES(item.REMARK) || '',
        _USER_ID: userInfo.userid || '',
      }));

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );
      const data = result.data;

      if (data.length === 0) {
        dispatch(
          showSnackbar({
            message: '저장 후 반환된 값이 없습니다.',
            type: 'error',
          })
        );
        return;
      } else if (data?.[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0].message || '에러가 발생했습니다.',
            type: 'error',
          })
        );
        return;
      }

      dispatch(
        showSnackbar({
          message: '저장되었습니다.',
          type: 'success',
        })
      );

      // 저장 후 재조회
      await SearchLogic1(searchInfo.custCd);
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion
  //#region 삭제

  //#endregion
  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async (_value1) => {
    setLoading(true);
    let tableData = [];

    try {
      // 검색 연월 추출 (currentYear, currentMonth 사용)
      const currentYear = searchInfo?.currentYear;
      const currentMonth = searchInfo?.currentMonth;
      let year = '';
      let month = '';

      if (currentYear && currentMonth) {
        year = currentYear.toString();
        month = currentMonth.toString();
      } else {
        // 날짜가 없으면 현재 연월 사용
        const now = dayjs();
        year = now.format('YYYY');
        month = now.format('MM');
      }

      // 일자 포맷팅 함수 (YYYY-MM-DD)
      const FormatDate = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
      };

      // 시간 포맷팅 함수 (HH:mm)
      const FormatTime = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
      };

      // 실시 시간(분) 포맷팅 함수 (초를 분으로 변환)
      const FormatDuration = (seconds) => {
        if (!seconds || seconds === 0) return '0분';

        const totalMinutes = Math.floor(Number(seconds) / 60);
        if (totalMinutes <= 0) return '0분';

        const hours = Math.floor(totalMinutes / 60);
        const remainMin = totalMinutes % 60;

        let result = '';
        if (hours > 0) result += `${hours}시간 `;
        if (remainMin > 0) result += `${remainMin}분`;
        return result.trim();
      };

      // tableData에 rowData1을 포맷팅하여 매핑
      tableData = rowData1.map((row) => ({
        ...row,
        TBM_DATE: FormatDate(row.TBM_DATE),
        TBM_START_DATE: FormatTime(row.TBM_START_DATE),
        TBM_END_DATE: FormatTime(row.TBM_END_DATE),
        TBM_ADD_DATE: FormatDuration(row.TBM_ADD_DATE),
      }));

      const printData = {
        FileName: 'TRA_BASIC_01',
        HeaderData: JSON.stringify({
          YEAR: year,
          MONTH: month,
        }),
        TableData: JSON.stringify(tableData),
      };

      Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  const audioUrl = selectedRowData1?.[0]?.TBM_ADD_MEETING
    ? Global.file.useUrl +
      'files/' +
      fixUrl(selectedRowData1[0].TBM_ADD_MEETING)
    : '';

  // 오디오 파일 다운로드
  const DownloadLogic1 = async (audioUrl) => {
    console.log(audioUrl);

    if (!audioUrl) {
      dispatch(
        showSnackbar({
          message: '오디오 파일이 존재하지 않습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      // 1) 파일 경로 정리
      const filePath = fixUrl(audioUrl);
      const fileName = audioUrl.split('/').pop() || 'audio.mp3';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      // 2) Axios 요청 (백엔드에서 파일 내려줌)
      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 3) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 4) 가짜 <a> 태그로 다운로드 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // 5) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#endregion
  const PreviewRender = () => {
    const rowData = selectedRowData1?.[0];

    // rowData가 없으면 Hook 사용 후에도 안전하게 return
    if (!rowData) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const filePath = rowData?.TBM_PHOTO || '';

    if (!filePath) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const ext = filePath.split('.').pop()?.toLowerCase();
    const fullUrl = Global.file.useUrl + 'files/' + fixUrl(filePath);
    console.log(fullUrl);

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const ResetLogic1 = () => {
    setRowData1([]);
  };

  const ResetLogic2 = () => {
    setRowData2([]);
  };
  const PopupClickEvent1 = async (e) => {
    rowClickData.current = e;
    // await loadInitialFile(e.chaebun, e.seq);
    //await SearchLogic2();
    setTimeout(() => setModalToggle1(true), 100);
  };

  return (
    <TRA_BASIC_01
      navigate={navigate}
      userInfo={userInfo}
      lanInfo={lanInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      rowData2={rowData2}
      setRowData2={setRowData2}
      selectedRowData2={selectedRowData2}
      setSelectedRowData2={setSelectedRowData2}
      changedRowData2={changedRowData2}
      setChangedRowData2={setChangedRowData2}
      searchRef={props.searchRef}
      filterClick1={props.filterClick1}
      setFilterClick1={props.setFilterClick1}
      searchClick1={props.searchClick1}
      setSearchClick1={props.setSearchClick1}
      addClick1={props.addClick1}
      setAddClick1={props.setAddClick1}
      saveClick1={props.saveClick1}
      setSaveClick1={props.setSaveClick1}
      deleteClick1={props.deleteClick1}
      setDeleteClick1={props.setDeleteClick1}
      printClick1={props.printClick1}
      setPrintClick1={props.setPrintClick1}
      gridRef1={gridRef1}
      gridRef2={gridRef2}
      tbmCdRef={tbmCdRef}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      audioUrl={audioUrl}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      ResetLogic2={ResetLogic2}
      SearchLogic1={SearchLogic1}
      SearchLogic2={SearchLogic2}
      SaveLogic1={SaveLogic1}
      PrintLogic1={PrintLogic1}
      PopupClickEvent1={PopupClickEvent1}
      PreviewRender={PreviewRender}
      DownloadLogic1={DownloadLogic1}
    />
  );
}

export default TRA_BASIC_01F;
